import { useState } from 'react';
import { Grid} from '@mui/material';
import { SplideSlide } from '@splidejs/react-splide';
import PresentTextField from '../../../../components/inputs/PresentTextField';

const styles = {
  inputWrapper: {
    paddingX: '0.25rem'
  },
}


const EmployeeDetailsReportsSlide = props => {
  const [report, setReport] = useState({
    date: new Date(props.date).toISOString().slice(0, 10),
    cause: props.cause,
    place: props.place,
    dischargeDate: new Date(props.dischargeDate).toISOString().slice(0, 10),
    assistants: props.assistants,
    summary: props.summary,
    results: props.results,
    observations: props.observations
  });

  const handleChange = e => {
    setReport({ ...report, [e.target.name]: e.target.value });
  }
  return (
    <SplideSlide>
      <Grid container sx={{ px: '3rem' }}>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField type="date" InputLabelProps={{ shrink: true }} label="Fecha del informe" name="date" value={report.date} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField label="Motivo del informe" name="cause" value={report.cause} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField label="Lugar y dirección del evento" name="place" value={report.place} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField type="date" InputLabelProps={{ shrink: true }} label="Fecha de declaración del colaborador" name="dischargeDate" value={report.dischargeDate} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField multiline rows={4} label="Nombres y cargos de los asistentes a la declaración" name="assistants" value={report.assistants} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField multiline rows={4} label="Resumen de la versión del colaborador" name="summary" value={report.summary} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField multiline rows={4} label="Resultados de la diligencia" name="results" value={report.results} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sx={styles.inputWrapper}>
          <PresentTextField multiline rows={4} label="Observaciones" name="observations" value={report.observations} onChange={handleChange} />
        </Grid>
      </Grid>
    </SplideSlide>
  );
}

export default EmployeeDetailsReportsSlide;
